import { Contract, Granularity, PeriodRow, SupplyPoint } from "../types";
import { ReturnDerived, Totals } from "../helpers";
import { KpiRow } from "../components/KpiRow";
import { ReturnKpiRow } from "../components/ReturnKpiRow";
import { SupplyChart } from "../components/SupplyChart";
import { PeriodBreakdownTable } from "../components/PeriodBreakdownTable";

export function OverviewTab({
  contract,
  totals,
  returnRequired,
  avgReturn,
  series,
  granularity,
  setGranularity,
  rows,
  returnDerived,
}: {
  contract: Contract;
  totals: Totals;
  returnRequired: number;
  avgReturn: number;
  series: SupplyPoint[];
  granularity: Granularity;
  setGranularity: (g: Granularity) => void;
  rows: PeriodRow[];
  returnDerived?: ReturnDerived | null;
}) {
  return (
    <div className="flex flex-col">
      <KpiRow
        contract={contract}
        totals={totals}
        returnRequired={returnRequired}
        avgReturn={avgReturn}
      />
      <SupplyChart
        series={series}
        granularity={granularity}
        setGranularity={setGranularity}
        receiver={contract.to}
      />
      <PeriodBreakdownTable
        rows={rows.slice(0, 14)}
        contractId={contract.id}
        enableExpand={granularity === "Day" || granularity === "Time Block"}
      />

      {returnDerived && (
        <>
          <div className="mt-2 mb-2 flex items-center gap-2">
            <span className="h-px flex-1 bg-[#E8EAEF]" />
            <span className="text-[12px] font-semibold tracking-wider text-[#828A99] uppercase">
              Return
            </span>
            <span className="h-px flex-1 bg-[#E8EAEF]" />
          </div>
          <ReturnKpiRow metrics={returnDerived.metrics} />
          <SupplyChart
            series={returnDerived.series}
            granularity={granularity}
            setGranularity={setGranularity}
            title={`Return To ${contract.from}`}
          />
          <PeriodBreakdownTable
            rows={returnDerived.rows.slice(0, 14)}
            contractId={contract.id}
            enableExpand={granularity === "Day" || granularity === "Time Block"}
            mode="return"
            title="Return breakdown"
          />
        </>
      )}
    </div>
  );
}

export default OverviewTab;
